import {
    Dialog,
    DialogTitle,
    Typography,
    IconButton,
    DialogContent,
  } from "@mui/material";
  import CloseIcon from "@mui/icons-material/Close";
  import { Box } from "@mui/material";
  import { memo } from "react";
  
  type PropsGenericModal = {
    open?: boolean;
    onClose?: () => void;
    title?: string;
    children?: React.ReactNode;
    maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
    maxHeight?: string;
  };
  
  const GenericModal: React.FC<PropsGenericModal> = ({
    open,
    onClose,
    title,
    children,
    maxWidth = "md",
    maxHeight,
  }) => {
    return (
      <>
        <Dialog
          open={open}
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              onClose?.();
            }
          }}
          fullWidth
          maxWidth={maxWidth}        
          PaperProps={{ sx: { backgroundColor: "#fff", ...(maxHeight && {maxHeight: maxHeight}) } }}
        >
          <DialogTitle
            sx={{
              fontWeight: 600,
              fontSize: "1.2rem",
              color: "#000",
              backgroundColor: "#f9f9f9",
              borderBottom: "1px solid #ffffff",
            }}
          >
            <Typography variant="h6" component="h1">
              {title}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => {
                onClose?.();
              }}
              sx={{
                mt: 0.5,
                position: "absolute",
                right: 8,
                top: 8,
                color: "#000",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers sx={{ backgroundColor: "#fff" }}>
            <Box sx={{ bgcolor: "#fff" }}>{children}</Box>
          </DialogContent>
        </Dialog>
      </>
    );
  };
  
  export default memo(GenericModal);
  